import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import {
  AgrPrimaryActionModule,
  AgrPageDetailModule,
  AgrResponsiveActionsModule,
} from '@next/core-lib/components';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TemplateRoutingModule } from './template-routing.module';
import { TemplateComponent } from './template.component';
import { SharedModule } from '../shared/shared.module';

import { TemplateEffects } from './store/effects';
import { templateReducer } from './store/reducer';

@NgModule({
  declarations: [TemplateComponent],
  imports: [
    SharedModule,
    TemplateRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatCheckboxModule,
    AgrPrimaryActionModule,
    AgrPageDetailModule,
    MatListModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    RouterModule,
    AgrResponsiveActionsModule,
  ],
  providers: [provideState('template', templateReducer), provideEffects([TemplateEffects])],
})
export class TemplateModule {}
